import React from "react";
import { Link } from "react-router-dom";

export default function App() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Welcome to Community Portal</h1>
      <p>
        Please visit our PASSUR login page or the PASSUR website to learn more about PASSUR.
        For any questions, please reach out to{" "}
        <a href="mailto:customerservice@passur.com">customerservice@passur.com</a>.
      </p>
      <p>
        <Link to="/reporttool">Go to ARiVA Portal</Link>
      </p>
    </div>
  );
}
